import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

// Components
import { NotifyComponent } from '../../components/notify/notify.component';
import { ProfileComponent } from '../../components/profile/profile.component';
import { PageNotFoundComponent } from '../../components/page-not-found/page-not-found.component';
import { ChangePasswordComponent } from '../../components/change-password/change-password.component';
import { ModalComponent } from '../../components/modal/modal/modal.component';

import { SidebarComponent } from '../../layout/dashbord/sidebar/sidebar.component';
import { FooterComponent } from '../../layout/dashbord/footer/footer.component';
import { HeaderComponent } from '../../layout/dashbord/header/header.component';
import { BreadcrumbComponent } from '../../layout/dashbord/breadcrumb/breadcrumb.component';

// Pipes
import { AsterisksPipe } from '../../pipes/Asterisks/asterisks.pipe';

// Services
import { NotificationService } from '../../../services/notificationServices/notification.service';
import { ValidationErrorService } from '../../../services/validation-error-service/validation-error.service';
import { EventsService } from '../../../services/eventServices/event.service';
import { NavigatorService } from '../../../services/navigatorService/navigator.service';
import { EncryptDataService } from '../../../services/encryption/encrypt-data.service';
import { CacheService } from '../../../services/cacheService/cache.service';
import {
  GuardService,
  RoleService
} from '../../../services/gaurdService/guard.service';
import { DecryptService } from '../../../services/decryptService/decrypt.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule
  ],

  declarations: [
    NotifyComponent,
    SidebarComponent,
    PageNotFoundComponent,
    FooterComponent,
    BreadcrumbComponent,
    HeaderComponent,
    ChangePasswordComponent,
    AsterisksPipe,
    ProfileComponent,
    ModalComponent
  ],

  providers: [
    NotificationService,
    ValidationErrorService,
    EventsService,
    NavigatorService,
    DecryptService,
    GuardService,
    RoleService,
    EncryptDataService,
    CacheService
  ],

  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule,

    NotifyComponent,
    SidebarComponent,
    PageNotFoundComponent,
    FooterComponent,
    BreadcrumbComponent,
    HeaderComponent,
    ChangePasswordComponent,
    AsterisksPipe,
    ProfileComponent,
    ModalComponent
  ]
})
export class SharedModule {}